import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../shared/url_helpers';
import IndexParams from './index_page/index_params';
import DigitalListings from './index_page/digital_listings';
import { APIRequest, CollectionHeaderManager, CollectionSEOContent, HashUtil } from '@reverbdotcom/discovery-ui';
import Category from '../taxonomy/category';

import Trait from '../taxonomy/trait';
import Helmet from 'react-helmet';

const softwareCategory = Category.findByUuid('e71b6e43-7217-4746-b4e3-64bf708a2664');
const operatingSystem = Trait.findByUuid('c6639f61-8884-45e2-9f78-9f1de059700b');
const fileType = Trait.findByUuid('2ae386f1-7144-4d0c-b8aa-6caba14faa6f');

class IndexPage extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      digitalListings: [],
      initialLoadComplete: false,
      totalCount: null,
      collectionHeader: {},
      facets: {
        category: [],
        brand: [],
        file_type: [],
        operating_system: [],
      },
    };

    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    this.fetchDigitalListings(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ loading: true });
    this.fetchDigitalListings(nextProps, this.scrollToTop);
  }

  scrollToTop() {
    this.setState({ scrollToTop: true });
  }

  get category() {
    if (this.indexParams.categorySlug) {
      return Category.findBySlug(this.indexParams.categorySlug);
    }
    return null;
  }

  categorySlugToUuid(slug) {
    const category = Category.findBySlug(slug);
    if (category) { return category.uuid; }
    return null;
  }

  operatingSystemUuid(slug) {
    if (!slug) { return null; }

    const traitValue = operatingSystem.findValueBySlug(slug);
    if (!traitValue) { return null; }

    return traitValue.uuid;
  }

  fileTypeUuids(slugs) {
    if (!slugs) { return null; }

    return slugs.reduce((uuids, slug) => {
      const traitValue = fileType.findValueBySlug(slug);
      if (traitValue) {
        return uuids.concat(traitValue.uuid);
      }
      return uuids;
    }, []);
  }

  fetchDigitalListings(props, callback) {
    const params = {
      category: this.categorySlugToUuid(props.params.categorySlug),
      brand: props.location.query.brand,
      operating_system: this.operatingSystemUuid(props.location.query.operating_system),
      file_type: this.fileTypeUuids(props.location.query.file_type),
      page: props.location.query.page,
      sort: props.location.query.sort,
      price_min: props.location.query.price_min,
      price_max: props.location.query.price_max,
    };

    const req = APIRequest.get(
      UrlHelpers.digitalListingsPath(params),
      {},
      { headers: { 'Accept-Version': '3.0' } },
    );

    req.done((response) => {
      this.setState({
        loading: false,
        digitalListings: response.digital_listings,
        totalCount: response.total,
        initialLoadComplete: true,
        pagination: { currentPage: response.current_page, totalPages: response.total_pages },
        facets: response.facets,
        error: false,
      });

      if (callback) { callback(); }
    });

    req.fail(() => {
      this.setState({
        loading: false,
        digitalListings: [],
        totalCount: 0,
        initialLoadComplete: true,
        error: true,
      });
    });
  }

  get indexParams() {
    return new IndexParams({
      push: this.props.router && this.props.router.push,
      location: this.props.location,
      params: this.props.params,
    });
  }

  backgroundImage() {
    const fullBleedImage = HashUtil.getSafely(
      this.state.collectionHeader,
      '_links.full_bleed_header_image',
    );

    if (!fullBleedImage) { return {}; }
    return { style: { backgroundImage: `url('${fullBleedImage.href}')` } };
  }

  get collectionHeaderParams() {
    const { categorySlug } = this.props.params;
    const category = Category.findBySlug(categorySlug) || softwareCategory;
    return { category_id: category.uuid };
  }

  get pageTitle() {
    const { categorySlug } = this.props.params;
    const category = Category.findBySlug(categorySlug);
    if (category) {
      return I18n.t('digitalProductsIndex.pageTitle', { categoryName: category.name });
    }
    return I18n.t('digitalProductsIndex.indexPageTitle');
  }

  renderResults() {
    return (
      <DigitalListings
        indexParams={this.indexParams}
        initialLoadComplete={this.state.initialLoadComplete}
        totalCount={this.state.totalCount}
        loading={this.state.loading}
        digitalListings={this.state.digitalListings}
        facets={this.state.facets}
        sort={this.props.location.query.sort}
        error={this.state.error}
        pagination={this.state.pagination}
        category={this.category}
        scrollToTop={this.state.scrollToTop}
      />
    );
  }

  render() {
    return (
      <div>
        <Helmet title={this.pageTitle} />
        <CollectionHeaderManager params={this.collectionHeaderParams} />
        {this.renderResults()}
        <CollectionSEOContent />
      </div>
    );
  }
}

IndexPage.propTypes = {
  params: PropTypes.object,
  location: PropTypes.object,
  router: PropTypes.object,
  routeParams: PropTypes.object,
};

export default IndexPage;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page.jsx